import React from 'react';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import Button from 'react-bootstrap/Button';
import cx from 'classnames';

const propTypes = {
  items: arrayOf(
    shape({
      id: oneOfType([string, number]).isRequired,
      uri: string.isRequired,
      name: string.isRequired,
    }),
  ).isRequired,
  onClick: func.isRequired,
  activeIds: arrayOf(oneOfType([string, number])).isRequired,
};

const WidgetButtonList = ({ items, onClick, activeIds }) => (
  <div className="c-widget-list">
    <ul className="c-widget-list__list">
      {items.map((item) => (
        <li key={item.id} className="c-widget-list__item">
          <Button
            className={cx('c-widget-list__link', {
              'c-widget-list__link--active': activeIds.some(
                (id) => id === item.id,
              ),
            })}
            onClick={(e) => onClick(item, e)}
          >
            {item.name}
          </Button>
        </li>
      ))}
    </ul>
  </div>
);

WidgetButtonList.propTypes = propTypes;

export default WidgetButtonList;
